import { compose, withHandlers, withProps } from 'recompose';
import { connect } from 'react-redux';
import { getQuerySearch, getPathname } from 'reselects';
import { replaceWithQuery as replace, pushWithQuery as push } from 'utils/routing';
import { searchVehicles } from 'redux/modules/vehicle-section/effects';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import VehicleListHeader from './component';

const sortDecreasingOrRemoveFilter = (currentSorting, newQuery, value) => {
  const order = currentSorting.charAt(0);

  return order === '-'
    ? delete newQuery['sorting']
    : Object.defineProperty(newQuery, 'sorting', { value: `-${value}` });
};

const actionCreators = {
  replace,
  push,
  searchVehicles,
};

const enhance = compose(
  injectIntl,
  withRouter,
  connect((state, ownProps) => {
    return {
      query: getQuerySearch(ownProps),
      pathname: getPathname(ownProps),
    };
  }, actionCreators),
  withProps(() => ({
    sortingFields: {
      weight: 'max_weight',
      height: 'container_height',
      pallets: 'max_pallets',
      width: 'container_width',
      lastJob: 'carrier__calculated_fields__last_journey_delivered_at',
      jobsDone: 'carrier__calculated_fields__number_of_completed_journeys',
      scoring: 'carrier__sales_attributes__scoring',
      carrier: 'carrier__name',
      engineType: 'engine_type',
      euroCategory: 'euro_category',
    },
  })),
  withHandlers({
    changeSortingFilter:
      ({ pathname, searchVehicles, query = {} }) =>
      (value) => {
        const { sorting } = query;
        let newQuery = { ...query };

        if (!sorting || !sorting.includes(value)) {
          newQuery['sorting'] = value;
        } else {
          sortDecreasingOrRemoveFilter(sorting, newQuery, value);
        }

        replace({ pathname, query: newQuery });
        searchVehicles(newQuery);
      },
    checkIfIsActive:
      ({ query }) =>
      (value) => {
        const { sorting } = query;

        if (!sorting) {
          return false;
        }

        return sorting.includes(value);
      },
  }),
  withHandlers({
    checkOrder:
      ({ query, checkIfIsActive }) =>
      (value) => {
        const { sorting } = query;

        if (checkIfIsActive(value)) {
          return sorting.charAt(0) === '-' ? 'desc' : 'asc';
        }

        return 'asc';
      },
  })
);

export default enhance(VehicleListHeader);
